import hres37uLabels from 'assets/labels/hres37u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hres37uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        typcer: faker.lorem.words(),
        staappr: '',
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: faker.lorem.words(),
        desc_codempap: faker.name.findName(),
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      dtereq: moment().format('DD/MM/YYYY'),
      numseq: faker.random.number().toString().substr(0, 1),
      desnote: faker.lorem.words(),
      dteuse: moment().format('DD/MM/YYYY'),
      flginc: '1',
      typcer: faker.lorem.word()
    }

    return mockTab1
  },
  approve () {
    return {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.name.findName(),
      dteappr: moment().format('DD/MM/YYYY'),
      staappr: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hres37u/mocker.js